import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

export const StyledCard = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: COLORS.white,
    height: '580px',
    borderRadius: '20px',
    padding: '24px',
    gap: '16px',
    boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.05)',
    maxWidth: '293px',
    minWidth: '270px',
  };
});

export const StyledImageWrapper = styled('div')(() => {
  return {
    width: '230px',
    height: '232px',
    borderRadius: '12px',
    alignSelf: 'center',
  };
});

export const StyledImage = styled('img')(() => {
  return {
    objectFit: 'fill',
    width: '230px',
    height: '232px',
  };
});
